import React, { useEffect } from 'react'
// import clientimg from '../assets/images/clients/1.png'
import aos from 'aos'
import $ from 'jquery'
import Slider from "react-slick";


const Testimonial = () => {
  useEffect(() => {
    aos.init({ duration: 2000 });
  }, [])

  // testimonialActivation();

  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    infinite: true,
    dots: true,
    adaptiveHeight: true,
    cssEase: 'linear',

    // prevArrow: '<button className="slide-arrow prev-arrow"><i className="feather-arrow-left"></i></button>',
    // nextArrow: '<button className="slide-arrow next-arrow"><i className="feather-arrow-right"></i></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };


  //  const testimonialActivation = () => {
  //   $('.testimonial-activation').slick({
  //       infinite: true,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       dots: true,
  //       arrows: true,
  //       adaptiveHeight: true,
  //       cssEase: 'linear',
  //       prevArrow: '<button className="slide-arrow prev-arrow"><i className="feather-arrow-left"></i></button>',
  //       nextArrow: '<button className="slide-arrow next-arrow"><i className="feather-arrow-right"></i></button>'
  //   });

  // $('.testimonial-item-one').slick({
  //     infinite: true,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: true,
  //     arrows: true,
  //     adaptiveHeight: true,
  //     cssEase: 'linear',
  //     prevArrow: '<button className="slide-arrow prev-arrow"><i className="feather-chevron-left"></i></button>',
  //     nextArrow: '<button className="slide-arrow next-arrow"><i className="feather-chevron-right"></i></button>',
  //     responsive: [
  //     {
  //         breakpoint: 1200,
  //         settings: {
  //             arrows: false,
  //         }
  //     }]
  // });



  return (
    <>


      {/* <!-- Start Testimonia Area  --> */}
      <div className="rn-testimonial-area testimonial-style-2 testimonial-with-carousel rn-section-gapTop pb--80 pb_md--50 section-separator" id="testimonial">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="section-title text-center mb--20 mb_md--20 mb_sm--20">
                <span className="subtitle">What Clients Say</span>
                <h2 className="title">Testimonial</h2>
              </div>
            </div>
          </div>


          <div className="testimonial-activation-item-3" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true">
            <Slider {...settings}>

              {/* <!-- Start single Testimonial --> */}
              <div className="rn-testimonial">
                <div className="testimonial-inner">
                  <div className="testimonial-header">
                    <div className="thumbnail">
                      {/* <img src={clientimg} alt="client-image" /> */}
                    </div>
                    <h5 className="ts-header">
                      <span className="text-color-primary">Marvin Laurent</span> 
                    </h5>
                  </div>
                  <div className="testimonial-body">
                    <p className="discription">
                      "Khuram is a good, skilled developer.
                      He is understanding well the development concepts, React, Javascript.

                      The only small feedback for him is to read carefully task details, it would make the implementations faster and smoother."
                    </p>
                  </div>
                </div>
              </div>
              {/* <!-- End single Testimonial --> */}

              {/* <!-- Start single Testimonial --> */}
              <div className="rn-testimonial">
                <div className="testimonial-inner">
                  <div className="testimonial-header">
                    <div className="thumbnail">
                      {/* <img src={clientimg} alt="client-image" /> */}
                    </div>
                    <h5 className="ts-header">
                      <span className="text-color-primary">Sallie Tan</span>
                    </h5>
                  </div>
                  <div className="testimonial-body">
                    <p className="discription">
                      "Task is very complicated but Khuram delivered good work and I enjoyed working with him.
                      His communication was top-notch, he met all deadlines, and his skills were strong.
                      I enjoyed working with Khuram."
                    </p>
                  </div>
                </div>
              </div>
              {/* <!-- End single Testimonial --> */}

              {/* <!-- Start single Testimonial --> */}
              <div className="rn-testimonial">
                <div className="testimonial-inner">
                  <div className="testimonial-header">
                    <div className="thumbnail">
                      {/* <img src={clientimg} alt="client-ima?ge" /> */}
                    </div>
                    <h5 className="ts-header">
                      <span className="text-color-primary">Qasim Zubair</span>
                    </h5>
                  </div>
                  <div className="testimonial-body">
                    <p className="discription">
                      "Khuram did a great job, we were super happy with his React/Node JS development skills.
                      He is amazing! Our entire team loved working with him. When performing him mental health coaching sessions patients
                      gave him a 5 star review 99% of the times.
                    </p>
                  </div>
                </div>
              </div>
              {/* <!-- End single Testimonial --> */}

              {/* <!-- Start single Testimonial --> */}
              <div className="rn-testimonial">
                <div className="testimonial-inner">
                  <div className="testimonial-header">
                    <div className="thumbnail">
                      {/* <img src={clientimg} alt="client-image" /> */}
                    </div>
                    <h5 className="ts-header">
                      <span className="text-color-primary">Rosa Morton</span>
                    </h5>
                  </div>
                  <div className="testimonial-body">
                    <p className="discription">
                    "Wonderful person to work with - plus great communication skills, quick turnaround time -
                     is very knowledgeable about the MERN stack technology. I will surely work with him again."
                    </p>
                  </div>
                </div>
              </div>
              {/* <!-- End single Testimonial --> */}
            </Slider>
          </div>
        </div>
      </div>
      {/* <!-- End Testimonia Area  --> */}

    </>
  );

}

export default Testimonial